/* PDP "Past dit op mijn balkon?" pop-up: open/close handling */
(function () {
  function openModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('balcony-check-lock');
    // Reset carousel to the first slide each time it opens
    var track = modal.querySelector('.balcony-check-modal__grid');
    if (track) {
      track.scrollLeft = 0;
    }
    setActiveDot(modal, 0);
  }

  function setActiveDot(modal, index) {
    var dots = modal.querySelectorAll('[data-bc-dot]');
    dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    var prev = modal.querySelector('[data-bc-arrow="prev"]');
    var next = modal.querySelector('[data-bc-arrow="next"]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= dots.length - 1;
  }

  function initCarousel(modal) {
    var track = modal.querySelector('.balcony-check-modal__grid');
    var dots = modal.querySelectorAll('[data-bc-dot]');
    if (!track || !dots.length || track.dataset.bcCarousel) return;
    track.dataset.bcCarousel = '1';

    var currentIndex = function () {
      return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    };
    var goTo = function (i) {
      var target = Math.max(0, Math.min(dots.length - 1, i));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    };

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        if (!track.clientWidth) return;
        setActiveDot(modal, currentIndex());
      });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });
    modal.querySelectorAll('[data-bc-arrow]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        goTo(currentIndex() + (arrow.getAttribute('data-bc-arrow') === 'next' ? 1 : -1));
      });
    });
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('balcony-check-lock');
  }

  function bindClose(modal) {
    if (modal.dataset.bcCloseBound) return;
    modal.dataset.bcCloseBound = '1';

    modal.querySelectorAll('[data-balcony-check-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    // Close on any click/tap outside the dialog, independent of overlay z-index.
    // pointerdown (not click) so the opening click doesn't immediately re-close it.
    document.addEventListener('pointerdown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (!e.target.closest('.balcony-check-modal__dialog')) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal(modal);
      }
    });
  }

  function init() {
    // Move the modal to <body> so position:fixed is relative to the viewport
    // (it can otherwise be trapped inside a transformed/contained ancestor).
    document.querySelectorAll('.balcony-check-modal').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      initCarousel(modal);
    });

    document.querySelectorAll('[data-balcony-check-open]').forEach(function (opener) {
      if (opener.dataset.bcBound) return;
      opener.dataset.bcBound = '1';

      opener.addEventListener('click', function (e) {
        e.preventDefault();
        var selector =
          opener.getAttribute('data-balcony-check-open') || opener.getAttribute('href');
        var modal = selector ? document.querySelector(selector) : null;
        if (modal) {
          bindClose(modal);
          openModal(modal);
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
